module.exports = __webpack_public_path__ + "static/media/web-backing.1766ebc9.png";